const URL_NOODLES = 'https://noodles-api.herokuapp.com/api/v1/';
// const BACK_END_URL = 'http://127.0.0.1:8000/api/users/';
const BACK_END_URL = 'https://noodles-api.herokuapp.com/api/users/';

export { URL_NOODLES, BACK_END_URL };
